export enum EJournalConstant {
    mealRecordType = 1,
    physicalActivityRecordType = 2,
    screenRecordType = 3
}